import { Component, OnInit, afterNextRender, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { ConfirmationService } from 'primeng/api';
import { SituacaoParcelaFeriasEnum } from 'src/app/components/shared/enums/situacao-parcela-ferias.enum';
import { addDays, addYears } from 'date-fns';
import { ExercicioSelecionado, ExerciciosService, ParcelaFerias } from 'src/app/services/exercicios.service';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { getDateFromYYYYMMDD, isValidDate } from 'src/app/components/shared/date-utils';
import { DataFormatadaPipe } from 'src/app/components/shared/pipes/dataFormatada.pipe';
import { SituacaoFuncionalEnum } from 'src/app/components/shared/enums/situacao-funcional.enum';
import { Message } from 'src/app/components/shared/message';
import { formatarMensagem } from 'src/app/components/shared/string-utils';

export interface ParcelaFeriasEmEdicao {
    id?: number;
    idParcelaPai?: number;
    ordem: number;
    geracao: number;
    dataInicio: Date;
    validacao: {
        sobreposto: boolean;
        foraOrdem: boolean;
        foraJanelaProgramacao: boolean;
        quantidadeDiasIgualZero: boolean;
        dataInvalida: boolean;
        edicaoDesabilitada: boolean;
    };
    quantidadeDias: number;
    dataFim: Date;
    situacao: {
        //Vindo da enum SituacaoParcelaFeriasEnum
        descricao: string;
        codigoCor: string;
    };
    adiantamentoSalarial: {
        valor: boolean;
        selecaoDesabilitada: boolean;
    };
    abonoPecuniario: {
        valor: boolean;
        selecaoDesabilitada: boolean;
    };
    adiantamentoDecimoTerceiro: {
        valor: boolean;
        selecaoDesabilitada: boolean;
    };
    parcelasDesconto: number;
    dataInterrupcao?: Date;
    motivoLegal?: string;
    justificativaInterrupcao?: string;
    documentoLegal?: string;
    dataPublicacaoDocumentoLegal?: Date;
}

@Component({
    selector: 'app-reprogramar-ferias',
    templateUrl: './reprogramar-ferias.component.html',
    styleUrls: ['./reprogramar-ferias.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ReprogramarFeriasComponent extends FeriasBaseComponent implements OnInit {
    submetido = false;
    houvePreenchimento = false;

    adicionaisSelecionados?: string[];

    selectedValues: string[] = ['abonoPecuniario', 'adiantamentoDecimoTerceiro'];
    selectedValue: string;

    exercicioSelecionado: ExercicioSelecionado;

    alocacaoSaldoDiasIncompleta = false;
    somaquantidadeDiasParcelas = 0;
    dataMinimaParcela: Date;
    dataMaximaParcela: Date;
    dataMaximaParcelaMaisUmAno: Date;

    naoPodeMarcarAdiantamentoDecimoTerceiro = false;
    naoPodeMarcarAbonoPecuniario = false;
    qtdParcelasFeriasExcluiveis = 0;

    justificativaParaAgendarFerias = '';
    justificativaInvalida = false;

    carrosseisParcelas: {
        ordemParcela: number;
        parcelasFerias: ParcelaFeriasEmEdicao[];
    }[] = []; //array de arrays

    opcoesParcelasDesconto: any[] = [];

    constructor(
        private exerciciosService: ExerciciosService,
        alertaMsgService: AlertMessageService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private dataFormatadaPipe: DataFormatadaPipe
    ) {
        super(alertaMsgService);

        this.exercicioSelecionado = this.router.getCurrentNavigation().extras.state.data;

        //Cria o array com as opções de parcelas para desconto
        for (let index = 1; index <= this.exercicioSelecionado.parametrosFeriasOrgao.quantidadeParcelasPagamento; index++) {
            this.opcoesParcelasDesconto.push(index);
        }

        afterNextRender(() => {
            this.alterarTituloTemplate('Gerenciar Férias');
            this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
            this.rolarParaTopo();
        });
    }

    obterDataAtual(): Date {
        const dataAtual = new Date();
        dataAtual.setHours(0, 0, 0, 0);
        return dataAtual;
    }

    get regimeCeletistaOuAnistiado(): boolean {
        return SituacaoFuncionalEnum.CLT.id === this.exercicioSelecionado.siglaRegime || SituacaoFuncionalEnum.ANISTIADO.id === this.exercicioSelecionado.siglaRegime;
    }

    get ministroPresidenteOuVice(): boolean {
        return (SituacaoFuncionalEnum.ESTATUTARIO.id === this.exercicioSelecionado.siglaRegime || SituacaoFuncionalEnum.NATUREZA_ESPECIAL.id === this.exercicioSelecionado.siglaRegime) && this.exercicioSelecionado.codigoSituacaoFuncional === 7;
    }

    /*get regimeEST(): boolean {
        return SituacaoFuncionalEnum.ESTATUTARIO.id === this.exercicioSelecionado.siglaRegime;
    }

    get regimeCDT(): boolean {
        return SituacaoFuncionalEnum.CONTRATO_TEMPORARIO.id === this.exercicioSelecionado.siglaRegime;
    }

    get regimeNES(): boolean {
        return SituacaoFuncionalEnum.NATUREZA_ESPECIAL.id === this.exercicioSelecionado.siglaRegime;
    }*/

    get msgParcelasSobrepostas(): string {
        return Message.ERRO_PARCELAS_COM_DATAS_SOBREPOSTAS;
    }

    get msgParcelasForaDeOrdem(): string {
        return Message.ERRO_DATA_INICIO_PARCELA_DEVE_SER_POSTERIOR;
    }

    get msgQuantidadeDiasIgualZero(): string {
        return Message.ERRO_DURACAO_MINIMA_PARCELA;
    }

    get msgAlocacaoSaldoDiasIncompleta(): string {
        return formatarMensagem(Message.ERRO_SOMA_PARCELAS_DIFERENTE_DO_SALDO, {
            totalDias: this.somaquantidadeDiasParcelas.toString(),
            saldoDias: this.exercicioSelecionado.saldoDias.toString()
        });
    }

    get msgCamposObrigatoriosNaoPreenchidos(): string {
        return Message.ERRO_CAMPOS_OBRIGATORIOS_NAO_PREENCHIDOS;
    }

    get msgCeletistaAnistiadoComParcelaForaPeriodoProgramacao(): string {
        return formatarMensagem(Message.ERRO_DATAS_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(this.dataMinimaParcela),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    get msgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao(): string {
        return formatarMensagem(Message.ERRO_DATA_INICIO_PARCELA_FORA_DO_INTERVALO, {
            dataInicio: this.dataFormatadaPipe.transform(this.dataMinimaParcela),
            dataFim: this.dataFormatadaPipe.transform(this.dataMaximaParcela)
        });
    }

    get msgJustificativaObrigatoria(): string {
        return Message.ERRO_JUSTIFICATIVA_OBRIGATORIA;
    }

    get umTercoSaldoFerias(): number {
        return Math.ceil(this.exercicioSelecionado.saldoDias / 3);
    }

    get qtdDiasMinimoParaAbono(): number {
        return this.umTercoSaldoFerias + 1;
    }

    get quantidadeMaximaParcelasPermitida(): number {
        return this.exercicioSelecionado.quantidadeMaximaParcelas ?? 3;
    }

    validarJustificativa() {
        if (!this.justificativaParaAgendarFerias || this.justificativaParaAgendarFerias.trim().length < 10 || this.justificativaParaAgendarFerias.trim().length > 300) {
            this.justificativaInvalida = true;
        } else {
            this.justificativaInvalida = false;
        }
    }

    onJustificativaChange(event) {
        this.justificativaParaAgendarFerias = event.target.value ? event.target.value.trim() : '';
    }

    registrarPreenchimento() {
        this.houvePreenchimento = true;

        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                if (parcela.situacao.descricao === SituacaoParcelaFeriasEnum.HOMOLOGADA.descricao) {
                    parcela.situacao.descricao = SituacaoParcelaFeriasEnum.NAO_SOLICITADA.descricao;
                    parcela.situacao.codigoCor = SituacaoParcelaFeriasEnum.NAO_SOLICITADA.extras.codigoCor;
                }
            });
        });
    }

    ngOnInit() {
        //Determinar a data mínima para a todas as parcelas
        const dataInicioPeriodoProgramacao = getDateFromYYYYMMDD(this.exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel ? this.exercicioSelecionado.dataInicioPeriodoProgramacaoDisponivel : this.exercicioSelecionado.dataInicioPeriodoProgramacao);
        const dataHoje = this.obterDataAtual();

        //Determinar a data mínima para a todas as parcelas
        if (dataInicioPeriodoProgramacao < dataHoje) {
            this.dataMinimaParcela = dataHoje;
            this.dataMinimaParcela.setDate(this.dataMinimaParcela.getDate() + 1);
        } else {
            this.dataMinimaParcela = dataInicioPeriodoProgramacao;
        }
        this.dataMaximaParcela = getDateFromYYYYMMDD(this.exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel ? this.exercicioSelecionado.dataFimPeriodoProgramacaoDisponivel : this.exercicioSelecionado.dataFimPeriodoProgramacao);

        //Adiciona mais um ano na dataMaximaParcela para parcelas oriundas de parcelas interrompidas
        this.dataMaximaParcelaMaisUmAno = addYears(this.dataMaximaParcela, 1);

        this.exercicioSelecionado.parcelas.forEach(parcela => {
            if (parcela.ordem !== 99) {
                //Ignorar parcelas Canceladas
                if (!this.carrosseisParcelas.some(carrossel => carrossel.ordemParcela === parcela.ordem)) {
                    //Adiciona um novo carrossel
                    this.carrosseisParcelas.push({
                        ordemParcela: parcela.ordem,
                        parcelasFerias: []
                    });
                }
            }

            const gerarParcelasCarrossel: Function = parcelaFerias => {
                //Função recursiva para gerar as parcelas

                const carrossel = this.carrosseisParcelas.find(carrossel => carrossel.ordemParcela === parcelaFerias.ordem);

                const geracaoParcela = parcelaFerias.geracao ? parcelaFerias.geracao : 0;

                carrossel.parcelasFerias.push({
                    id: parcelaFerias.id,
                    idParcelaPai: parcelaFerias.idParcelaPai,
                    ordem: parcelaFerias.ordem,
                    geracao: geracaoParcela,
                    dataInicio: getDateFromYYYYMMDD(parcelaFerias.dataInicio),
                    validacao: {
                        sobreposto: false,
                        foraOrdem: false,
                        foraJanelaProgramacao: false,
                        quantidadeDiasIgualZero: false,
                        dataInvalida: false,
                        edicaoDesabilitada: SituacaoParcelaFeriasEnum.HOMOLOGADA.descricao !== SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao ? true : false
                    },
                    dataFim: getDateFromYYYYMMDD(parcelaFerias.dataFim),
                    quantidadeDias: parcelaFerias.quantidadeDias,
                    situacao: {
                        descricao: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao,
                        codigoCor: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).extras.codigoCor
                    },
                    adiantamentoSalarial: {
                        valor: parcelaFerias.adiantamentoSalarial,
                        selecaoDesabilitada: false
                    },
                    abonoPecuniario: {
                        valor: parcelaFerias.abonoPecuniario,
                        selecaoDesabilitada: false
                    },
                    adiantamentoDecimoTerceiro: {
                        valor: parcelaFerias.adiantamentoDecimoTerceiro,
                        selecaoDesabilitada: false
                    },
                    parcelasDesconto: parcelaFerias.parcelasDesconto,
                    dataInterrupcao: parcelaFerias.dataInterrupcao,
                    motivoLegal: parcelaFerias.motivoLegal,
                    justificativaInterrupcao: parcelaFerias.justificativaInterrupcao,
                    documentoLegal: parcelaFerias.documentoLegal,
                    dataPublicacaoDocumentoLegal: parcelaFerias.dataPublicacaoDocumentoLegal
                });

                if (parcelaFerias.parcelaFilha) {
                    gerarParcelasCarrossel(parcelaFerias.parcelaFilha);
                }

                //ordenar as parcelas
                carrossel.parcelasFerias.sort((a, b) => a.geracao - b.geracao);
            };

            gerarParcelasCarrossel(parcela);
        });
        //ordenar as parcelas
        this.carrosseisParcelas.sort((a, b) => a.ordemParcela - b.ordemParcela);

        this.naoPodeMarcarAdiantamentoDecimoTerceiro = this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.situacao.descricao !== SituacaoParcelaFeriasEnum.HOMOLOGADA.descricao && parcela.situacao.descricao !== SituacaoParcelaFeriasEnum.NAO_SOLICITADA.descricao && parcela.adiantamentoDecimoTerceiro.valor;
            });
        });

        this.naoPodeMarcarAbonoPecuniario = this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.situacao.descricao !== SituacaoParcelaFeriasEnum.HOMOLOGADA.descricao && parcela.situacao.descricao !== SituacaoParcelaFeriasEnum.NAO_SOLICITADA.descricao && parcela.abonoPecuniario.valor;
            });
        });

        //Bloqueia a seleção de adiantamento de 13º de cada parcela se a data de início for maior que 30/06
        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                if (parcela.dataInicio.getMonth() + 1 > 6) {
                    parcela.adiantamentoDecimoTerceiro.selecaoDesabilitada = true;
                }
            });
        });

        //Ajusta as parcelas caso exista alguma inconsistência entre os parametrosFeriasOrgao atuais e o que já está homologado para o exercício de férias
        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                if (!this.exercicioSelecionado.parametrosFeriasOrgao.pagamentoNoAdiantamento) {
                    if (parcela.adiantamentoSalarial.valor) {
                        //Se não pode mais solicitar Adiantamento Salarial, "desmarca" de todas as parcelas
                        parcela.adiantamentoSalarial.valor = false;
                        parcela.parcelasDesconto = null;
                        this.registrarPreenchimento();
                    }
                } else {
                    //Se o valor de parcelasDesconto for maior do que o permitido nos parametrosFeriasOrgao atuais, apaga o valor
                    if (parcela.parcelasDesconto > this.exercicioSelecionado.parametrosFeriasOrgao.quantidadeParcelasPagamento) {
                        parcela.parcelasDesconto = null;
                        this.registrarPreenchimento();
                    }
                }
            });
        });

        this.atualizarQuantidadeParcelasEditaveis();
    }

    atualizarQuantidadeParcelasEditaveis() {
        this.qtdParcelasFeriasExcluiveis = 0;

        this.carrosseisParcelas.forEach(carrossel => {
            this.qtdParcelasFeriasExcluiveis += carrossel.parcelasFerias.filter(parcela => {
                return !parcela.validacao.edicaoDesabilitada && parcela.geracao == 0;
            }).length;
        });
    }

    confirmarVoltar() {
        if (this.houvePreenchimento) {
            this.confirmationService.confirm({
                key: 'confirmPadrao',
                header: 'Confirmação',
                message: Message.CONFIRMACAO_ABANDONAR_TELA_COM_PERDA_DE_DADOS,
                accept: async () => {
                    this.voltar();
                }
            });
        } else {
            this.voltar();
        }
    }

    voltar() {
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios']);
    }

    existeSobreposicaoDeParcelas(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.validacao.sobreposto;
            });
        });
    }

    existeParcelaForaOrdem(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.validacao.foraOrdem;
            });
        });
    }

    existeCampoObrigatorioNaoInformado(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return !parcela.dataInicio || (!parcela.quantidadeDias && parcela.quantidadeDias !== 0) || (parcela.adiantamentoSalarial.valor && !parcela.parcelasDesconto);
            });
        });
    }

    existeParcelaComQuantidadeDiasIgualZero(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.validacao.quantidadeDiasIgualZero;
            });
        });
    }

    existeParcelaComQuantidadeMinimaDias(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.quantidadeDias >= 14;
            });
        });
    }

    existeParcelaForaPeriodoProgramacao(): boolean {
        return this.carrosseisParcelas.some(carrossel => {
            return carrossel.parcelasFerias.some(parcela => {
                return parcela.dataInicio && parcela.validacao.foraJanelaProgramacao;
            });
        });
    }

    confirmarReprogramacao() {
        if (!this.houvePreenchimento) {
            this.getAlertaMsgService().error(Message.AVISO_REPROGRAMACAO_SEM_ALTERACOES);
            return;
        }

        this.submetido = true;
        this.clearMessages();

        let podeReprogramar = true;

        //Validação da quantidade mínima de dias
        if (this.existeParcelaComQuantidadeDiasIgualZero()) {
            this.getAlertaMsgService().error(this.msgQuantidadeDiasIgualZero);
            podeReprogramar = false;
        }

        // Validação da soma de dias das parcelas
        if (this.alocacaoSaldoDiasIncompleta) {
            this.getAlertaMsgService().error(this.msgAlocacaoSaldoDiasIncompleta);
            podeReprogramar = false;
        }

        // Validação da justificativa
        this.validarJustificativa();
        if (this.justificativaInvalida) {
            this.getAlertaMsgService().error(this.msgJustificativaObrigatoria);
            podeReprogramar = false;
        }

        //Validações impeditivas
        if (this.existeCampoObrigatorioNaoInformado()) {
            //Reseta todos os campos com data em branco
            this.carrosseisParcelas.forEach(carrossel => {
                carrossel.parcelasFerias.forEach(parcela => {
                    if (!parcela.dataInicio) {
                        parcela.validacao.foraJanelaProgramacao = false;
                        parcela.validacao.dataInvalida = false;
                    }
                });
            });

            this.getAlertaMsgService().error(this.msgCamposObrigatoriosNaoPreenchidos);
            podeReprogramar = false;
        }
        if (this.existeSobreposicaoDeParcelas()) {
            this.getAlertaMsgService().error(this.msgParcelasSobrepostas);
            podeReprogramar = false;
        }
        if (this.existeParcelaForaOrdem()) {
            this.getAlertaMsgService().error(this.msgParcelasForaDeOrdem);
            podeReprogramar = false;
        }
        if (this.existeParcelaForaPeriodoProgramacao()) {
            if (this.regimeCeletistaOuAnistiado) {
                this.getAlertaMsgService().error(this.msgCeletistaAnistiadoComParcelaForaPeriodoProgramacao);
            } else {
                this.getAlertaMsgService().error(this.msgNaoCeletistaAnistiadoComParcelaForaPeriodoProgramacao);
            }
            podeReprogramar = false;
        }

        if (podeReprogramar) {
            this.confirmationService.confirm({
                key: 'confirmPadrao',
                header: 'Confirmação',
                message: formatarMensagem(Message.CONFIRMACAO_REPROGRAMAR_FERIAS, {
                    anoExercicio: this.exercicioSelecionado.anoExercicio + ''
                }),
                accept: async () => {
                    this.reprogramar();
                }
            });
        }
    }

    reprogramar() {
        const parcelasProgramadas: ParcelaFerias[] = [];

        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                parcelasProgramadas.push({
                    id: parcela.id,
                    idParcelaPai: parcela.idParcelaPai,
                    ordem: parcela.ordem,
                    dataInicio: parcela.dataInicio,
                    quantidadeDias: parcela.quantidadeDias,
                    adiantamentoSalarial: parcela.adiantamentoSalarial.valor,
                    abonoPecuniario: parcela.abonoPecuniario.valor,
                    adiantamentoDecimoTerceiro: parcela.adiantamentoDecimoTerceiro.valor,
                    parcelasDesconto: parcela.adiantamentoSalarial.valor ? parcela.parcelasDesconto : null,
                    situacao: parcela.situacao.descricao
                });
            });
        });

        const reprogramarFerias: any = {
            parcelas: parcelasProgramadas,
            justificativaParaAgendarFerias: this.justificativaParaAgendarFerias
        };

        this.exerciciosService.reprogramarFerias(this.exercicioSelecionado.idFerias, reprogramarFerias).subscribe(data => {
            if (data.sucessoEnvioMensageria) {
                this.getAlertaMsgService().setAwatingSuccessMessage(Message.FERIAS_REPROGRAMADAS_COM_SUCESSO_COM_OBSERVACAO);
            } else {
                this.getAlertaMsgService().setAwatingWarnMessage(Message.AVISO_ACAO_REALIZADA_SEM_NOTIFICACAO_AUTOMATICA);
            }

            this.voltar();
        });
    }

    inputDataInicioChange(parcela: ParcelaFeriasEmEdicao, event) {
        if (!parcela.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            if (parcela.dataInicio || event.target.value === '') {
                this.dataInicioChange(parcela);
            } else if (event.target.value) {
                if (event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                    //Verificar se o event.target.value que está no formado dd/mm/yyyy é uma data válida
                    const partesData = event.target.value.split('/');
                    if (isValidDate(parseInt(partesData[2]), parseInt(partesData[1]), parseInt(partesData[0]))) {
                        parcela.validacao.foraJanelaProgramacao = true;
                        parcela.validacao.dataInvalida = false;
                        //Apaga a data de término
                        parcela.dataFim = undefined;
                    } else {
                        parcela.validacao.foraJanelaProgramacao = false;
                        parcela.validacao.dataInvalida = true;
                        //Apaga a data de término
                        parcela.dataFim = undefined;
                    }
                }
            }
        }
    }

    blurDataInicioChange(parcela: ParcelaFeriasEmEdicao, event) {
        if (!parcela.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            if (!parcela.dataInicio && event.target.value !== '' && !event.target.value.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                parcela.validacao.foraJanelaProgramacao = false;
                parcela.validacao.dataInvalida = true;

                //Apaga a data de término
                parcela.dataFim = undefined;
            }
        }
    }

    dataInicioChange(parcela: ParcelaFeriasEmEdicao) {
        if (!parcela.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            //Adiantamento de 13º só é possível quando a data de inicio for até o dia 30/06
            if (!parcela.dataInicio || parcela.dataInicio.getMonth() + 1 > 6) {
                parcela.adiantamentoDecimoTerceiro.valor = false;
                parcela.adiantamentoDecimoTerceiro.selecaoDesabilitada = true;
            } else {
                parcela.adiantamentoDecimoTerceiro.selecaoDesabilitada = false;
            }

            this.calcularDataFim(parcela);
        }
    }

    quantidadeDiasChange(parcela: ParcelaFeriasEmEdicao, criarNovasParcelas = true) {
        if (!parcela.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            //Transformar a quantidadeDias para number
            parcela.quantidadeDias = parcela.quantidadeDias || parcela.quantidadeDias === 0 ? parseInt('' + parcela.quantidadeDias) : undefined;

            if (this.regimeCeletistaOuAnistiado) {
                //CLT/ANS: Não pode pedir abono pecuniário se a quantidade de dias for menor que 1/3 do saldo + 1 dia
                parcela.abonoPecuniario.selecaoDesabilitada = false;
                if (!parcela.quantidadeDias || parcela.quantidadeDias < this.qtdDiasMinimoParaAbono) {
                    parcela.abonoPecuniario.valor = false;
                    parcela.abonoPecuniario.selecaoDesabilitada = true;
                }
            }

            parcela.validacao.quantidadeDiasIgualZero = false;
            //Não pode ter quantidade de dias = 0
            if (parcela.quantidadeDias === 0) {
                parcela.validacao.quantidadeDiasIgualZero = true;
            }

            this.calcularDataFim(parcela, criarNovasParcelas);

            this.verificarAlocacaoSaldoDias();
        }
    }

    parcelasDescontoChange() {
        this.registrarPreenchimento();
    }

    adiantamentoSalarialChange(parcelaAlterada: ParcelaFeriasEmEdicao) {
        if (parcelaAlterada.adiantamentoSalarial.valor) {
            parcelaAlterada.parcelasDesconto = 1;
        } else {
            parcelaAlterada.parcelasDesconto = null;
        }
        this.registrarPreenchimento();
    }

    abonoPecuniarioChange(parcelaAlterada: ParcelaFeriasEmEdicao) {
        if (!parcelaAlterada.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            //Desmarca todos os outros
            if (parcelaAlterada.abonoPecuniario.valor) {
                this.carrosseisParcelas.forEach(carrossel => {
                    carrossel.parcelasFerias.forEach(parcela => {
                        if (parcelaAlterada.ordem !== parcela.ordem) {
                            if (parcela.abonoPecuniario.valor) {
                                parcela.abonoPecuniario.valor = false;
                                this.abonoPecuniarioChange(parcela);
                            }

                            parcela.abonoPecuniario.valor = false;
                        }
                    });
                });

                parcelaAlterada.quantidadeDias = parcelaAlterada.quantidadeDias - this.umTercoSaldoFerias;
            } else {
                parcelaAlterada.quantidadeDias = parcelaAlterada.quantidadeDias + this.umTercoSaldoFerias;
            }

            this.calcularDataFim(parcelaAlterada);
        }
    }

    adiantamentoDecimoTerceiroChange(parcelaAlterada: ParcelaFeriasEmEdicao) {
        if (!parcelaAlterada.validacao.edicaoDesabilitada) {
            this.registrarPreenchimento();

            //Desmarca todos os outros
            if (parcelaAlterada.adiantamentoDecimoTerceiro.valor) {
                this.carrosseisParcelas.forEach(carrossel => {
                    carrossel.parcelasFerias.forEach(parcela => {
                        if (parcelaAlterada.ordem !== parcela.ordem) {
                            parcela.adiantamentoDecimoTerceiro.valor = false;
                        }
                    });
                });
            }
        }
    }

    criarNovasParcelas() {
        let totalquantidadeDiasParcelas = 0;
        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                totalquantidadeDiasParcelas += parcela.quantidadeDias;
                //Soma 1/3 do saldo de férias se tiver abono pecuniário
                if (parcela.abonoPecuniario.valor) {
                    totalquantidadeDiasParcelas += this.umTercoSaldoFerias;
                }
            });
        });

        if (totalquantidadeDiasParcelas && totalquantidadeDiasParcelas < this.exercicioSelecionado.saldoDias && this.carrosseisParcelas.length < this.quantidadeMaximaParcelasPermitida) {
            this.carrosseisParcelas.push({
                ordemParcela: this.carrosseisParcelas.length + 1,
                parcelasFerias: [
                    {
                        ordem: this.carrosseisParcelas.length + 1,
                        geracao: 0,
                        dataInicio: undefined,
                        validacao: {
                            sobreposto: false,
                            foraOrdem: false,
                            foraJanelaProgramacao: false,
                            quantidadeDiasIgualZero: false,
                            dataInvalida: false,
                            edicaoDesabilitada: false
                        },
                        quantidadeDias: this.exercicioSelecionado.saldoDias - totalquantidadeDiasParcelas,
                        dataFim: undefined,
                        situacao: {
                            descricao: SituacaoParcelaFeriasEnum.NAO_SOLICITADA.descricao,
                            codigoCor: SituacaoParcelaFeriasEnum.NAO_SOLICITADA.extras.codigoCor
                        },
                        adiantamentoSalarial: {
                            valor: false,
                            selecaoDesabilitada: false
                        },
                        abonoPecuniario: {
                            valor: false,
                            selecaoDesabilitada: false
                        },
                        adiantamentoDecimoTerceiro: {
                            valor: false,
                            selecaoDesabilitada: false
                        },
                        parcelasDesconto: 1
                    }
                ]
            });

            this.quantidadeDiasChange(this.carrosseisParcelas.at(-1).parcelasFerias.at(-1));
        }

        this.atualizarQuantidadeParcelasEditaveis();
    }

    calcularDataFim(parcela: ParcelaFeriasEmEdicao, criarNovasParcelas = true) {
        if (!parcela.quantidadeDias || !parseInt(parcela.quantidadeDias as any)) {
            parcela.dataFim = undefined;
        } else {
            if (!parcela.dataInicio) {
                parcela.dataFim = undefined;
            }

            if (criarNovasParcelas) {
                this.criarNovasParcelas();
            }

            if (parcela.dataInicio) {
                parcela.dataFim = addDays(parcela.dataInicio, parcela.quantidadeDias - 1);
            }
        }

        this.validarPeriodos();
    }

    confirmarExclusaoParcela(parcela: ParcelaFeriasEmEdicao) {
        this.confirmationService.confirm({
            key: 'confirmPadrao',
            header: 'Confirmação de exclusão',
            message: Message.CONFIRMACAO_EXCLUIR_PARCELA,
            accept: () => {
                this.excluirParcela(parcela);
            }
        });
    }

    excluirParcela(parcelaASerExcluida: ParcelaFeriasEmEdicao) {
        if (!parcelaASerExcluida.validacao.edicaoDesabilitada) {
            //Primeiro desmarca o abono pecuniário da parcela a ser excluída
            if (parcelaASerExcluida.abonoPecuniario.valor) {
                parcelaASerExcluida.abonoPecuniario.valor = false;
                this.abonoPecuniarioChange(parcelaASerExcluida);
            }

            //Excluir a parcela
            this.carrosseisParcelas.splice(parcelaASerExcluida.ordem - 1, 1);

            //Atualiza a ordem de cada parcela
            this.carrosseisParcelas.forEach((carrossel, indice) => {
                carrossel.ordemParcela = indice + 1;

                carrossel.parcelasFerias.forEach(parcela => {
                    parcela.ordem = indice + 1;
                });
            });

            //Se a parcela anterior estiver com abono pecuniário
            if (this.carrosseisParcelas.at(-1).parcelasFerias.at(-1).abonoPecuniario.valor) {
                this.carrosseisParcelas.at(-1).parcelasFerias.at(-1).quantidadeDias += parcelaASerExcluida.quantidadeDias + this.umTercoSaldoFerias;
                this.quantidadeDiasChange(this.carrosseisParcelas.at(-1).parcelasFerias.at(-1), false);

                //Marca novamente o abono pecuniário da última parcela
                this.abonoPecuniarioChange(this.carrosseisParcelas.at(-1).parcelasFerias.at(-1));
            } else {
                //Adiciona a quantidade de dias da parcela excluída para a última parcela do exercício
                this.carrosseisParcelas.at(-1).parcelasFerias.at(-1).quantidadeDias += parcelaASerExcluida.quantidadeDias;
                this.quantidadeDiasChange(this.carrosseisParcelas.at(-1).parcelasFerias.at(-1), false);
            }

            //Verifica se os periodos estão corretos
            this.validarPeriodos();

            this.verificarAlocacaoSaldoDias();

            this.atualizarQuantidadeParcelasEditaveis();
        }
    }

    verificarAlocacaoSaldoDias() {
        let faltaPreenchimento = false;
        let quantidadeMinimaInformada = true;
        this.somaquantidadeDiasParcelas = 0;

        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                if (parcela.quantidadeDias || parcela.quantidadeDias === 0) {
                    this.somaquantidadeDiasParcelas += parcela.quantidadeDias;

                    if (parcela.abonoPecuniario.valor) {
                        this.somaquantidadeDiasParcelas += this.umTercoSaldoFerias;
                    }

                    if (parcela.validacao.quantidadeDiasIgualZero) {
                        quantidadeMinimaInformada = false;
                    }
                } else {
                    faltaPreenchimento = true;
                }
            });
        });

        this.alocacaoSaldoDiasIncompleta = !faltaPreenchimento && quantidadeMinimaInformada && this.somaquantidadeDiasParcelas !== this.exercicioSelecionado.saldoDias;
    }

    validarPeriodos() {
        //Sempre coloca como false o periodoSobreposto da primeira parcela
        this.carrosseisParcelas.at(0).parcelasFerias.forEach(parcela => {
            parcela.validacao.sobreposto = false;
        });

        //Reinicia a validação de sobreposição e fora de ordem para todas as parcelas
        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                parcela.validacao.sobreposto = false;
                parcela.validacao.foraOrdem = false;
                parcela.validacao.foraJanelaProgramacao = false;
                parcela.validacao.dataInvalida = false;
            });
        });

        //Validação
        this.carrosseisParcelas.forEach(carrossel => {
            carrossel.parcelasFerias.forEach(parcela => {
                if (parcela.dataFim) {
                    if (parcela.geracao == 0) {
                        //Se não for parcela oriunda de interrupção, valida só a parcela seguinte
                        //periodoSobreposto
                        const carrosselSeguinte = this.carrosseisParcelas.at(parcela.ordem);
                        if (carrosselSeguinte) {
                            const parcelaSeguinte = carrosselSeguinte.parcelasFerias.at(carrosselSeguinte.parcelasFerias.length - 1);
                            if (parcelaSeguinte) {
                                if (parcelaSeguinte.dataInicio && parcelaSeguinte.dataInicio.getTime() <= parcela.dataFim.getTime()) {
                                    if (parcelaSeguinte.dataFim && parcelaSeguinte.dataFim.getTime() >= parcela.dataFim.getTime()) {
                                        parcelaSeguinte.validacao.sobreposto = true;
                                    } else {
                                        if (parcelaSeguinte.geracao && parcelaSeguinte.geracao > 0) {
                                            parcelaSeguinte.validacao.sobreposto = true;
                                        } else {
                                            parcelaSeguinte.validacao.foraOrdem = true;
                                        }
                                    }
                                }
                            }
                        }
                    } else if (parcela.geracao && parcela.geracao > 0) {
                        //Se for oriunda de interrupção, validar sobreposição com todas as outras parcelas
                        this.carrosseisParcelas.forEach(outroCarrossel => {
                            if (carrossel.ordemParcela != outroCarrossel.ordemParcela && carrossel.ordemParcela < outroCarrossel.ordemParcela) {
                                outroCarrossel.parcelasFerias.forEach(outraParcela => {
                                    if (outraParcela.dataInicio && outraParcela.dataInicio.getTime() <= parcela.dataFim.getTime()) {
                                        if (outraParcela.dataFim && outraParcela.dataFim.getTime() >= parcela.dataFim.getTime()) {
                                            outraParcela.validacao.sobreposto = true;
                                        } else if (outraParcela.dataFim && outraParcela.dataFim.getTime() >= parcela.dataInicio.getTime()) {
                                            if (outraParcela.geracao && outraParcela.geracao > 0) {
                                                outraParcela.validacao.sobreposto = true;
                                            } else {
                                                outraParcela.validacao.foraOrdem = true;
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                }

                if (!parcela.validacao.sobreposto) {
                    if (!parcela.validacao.edicaoDesabilitada) {
                        if (parcela.dataInicio && parcela.dataInicio < this.dataMinimaParcela) {
                            parcela.validacao.foraJanelaProgramacao = true;
                            //Apaga a data de término
                            parcela.dataFim = undefined;
                        } else if (this.regimeCeletistaOuAnistiado && parcela.dataFim && parcela.dataFim > this.dataMaximaParcela) {
                            //Só verifica a data de termino fora da janela de programação se for CLT/ANS
                            parcela.validacao.foraJanelaProgramacao = true;
                            //Apaga a data de término
                            parcela.dataFim = undefined;
                        }
                    }
                }
            });
        });
    }
}
